import React from "react";
import styles from "./CardImage.module.scss";
import Button from "../Button/Button";
import cn from "classnames";
import HtmlContent from "../HtmlContent/HtmlContent";
// import WebpLazyImage from "../WebpLazyImage/WebpLazyImage";
import LazyImage from "../LazyImage/LazyImage";

interface CardImageProps {
    title: string;
    text: string;
    image?: string;
    webpImage?: string;
    link?: string;
    className?: keyof typeof styles;
    onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
}

const CardImage: React.FC<CardImageProps> = (
    {
        title,
        text,
        image,
        webpImage,
        link,
        className,
        onClick
    }) => {
    return (
        <div className={cn(styles.cardImage, className ? styles[className] : undefined)}>
            <div className={styles.cardImageRow}>
                <p className={styles.cardImageTitle}>{title}</p>
                {text && <HtmlContent className={styles.cardImageText} html={text}/>}
                {link &&
                    <Button onClick={onClick} className={styles.cardImageButton}>
                        Узнать больше
                    </Button>}
            </div>
            <img className={styles.cardImageImage} src={image} alt={title}/>
        </div>
    )
}
export default CardImage;